"use strict";
// special thanks to this StackOverflow thread
// https://stackoverflow.com/questions/57086672/element-implicitly-has-an-any-type-because-expression-of-type-string-cant-b
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serializer = void 0;
const register_1 = require("./register");
// This class is a port of the 'Streamable' class from
// https://github.com/Chia-Network/chia-blockchain/blob/main/chia/util/streamable.py#L260
class Serializer {
    // for some reason, serializing objects for hashing != serializing objects for the comm protocol
    static serialize(object) {
        let buf = Buffer.from([]);
        const props = Object.getPrototypeOf(object)[register_1.propertySerializerName];
        for (const prop of Object.keys(props)) {
            buf = props[prop].serialize(object[prop], buf);
        }
        return buf;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static deserialize(classType, data) {
        let buf = data instanceof Buffer ? data : Buffer.from(data, "hex");
        const props = classType.prototype[register_1.propertySerializerName];
        const result = new classType();
        for (const prop of Object.keys(props)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const deserializationResult = props[prop].deserialize(buf);
            result[prop] = deserializationResult[0];
            buf = deserializationResult[1];
        }
        return result;
    }
}
exports.Serializer = Serializer;
//# sourceMappingURL=serializer.js.map